import React, { useState, useEffect, useRef } from 'react';
import { handleChange, handleSubmit } from "../../Controller/CreateCustomerDetailController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import CustomerAccountTypeService from "../../../Setup/controller/CustomerAccountTypeController/CustomerAccountTypeController";
import TeamService from "../../../Setup/controller/TeamController/TeamController";
import TitleService from "../../../Setup/controller/TitleController/TitleController";
import CourierService from "../../../Setup/controller/CourierController/CourierController";
import TaxService from "../../../Setup/controller/TaxCodesController/TaxCodeController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import StockCategoryService from "../../../Setup/controller/StockCategoryController/StockCategoryController";
import CustomerService from "../../../Customer/Controller/CustomerController";
import { useNavigate, useLocation } from 'react-router-dom';
import HelpSite from "../../../Common/HelpLink";
import Website from "../../../Common/website";
import SendEmail from "../../../Common/SendEmail";
import JobRoleService from "../../../Setup/controller/JobRoleController/JobRoleController";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";
import IndustrySectorService from "../../../Setup/controller/IndustrySectorController/IndustrySectorController";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import CreateCommunicationModal from './CreateCustomerHistoryModal';
import CustomerHistoryService from "../../Controller/CustomerHistoryController";
import Swal from 'sweetalert2';
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
import { getMergedPDFBlob } from '../../../Common/ReportPDFService';
function CustomerDetail({ ClientCompanyID, IsCustomerSelection, onClose, onNext, onPrevious, isLock, onSuccess }) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({ ClientCompanyID: 0, Amount: "0.00", PK_ClientCompanyType_ID: 0, ContactPreferred: "Email", PK_StockCategory_ID: "0", vc_Category: "", LinkedIn: "" });
    const [CountryList, setCountries] = useState([]);
    const [AccountTypesList, setAccountTypes] = useState([]);
    const [TeamList, setTeams] = useState([]);
    const [TitleList, setTitles] = useState([]);
    const [CourierList, setCouriers] = useState([]);
    const [taxCodeList, setTaxCodes] = useState([]);
    const [currencyList, setCurrenyDate] = useState([]);
    const [jobRoleList, setJobRoles] = useState([]);
    const [DiscountsList, setDiscounts] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showAccountNoMessage, setshowAccountNoMessage] = useState(false);
    const [showCompanyExistMessage, setshowCompanyExistMessage] = useState(false);
    const modalRef = useRef(null);  // Reference to the modal
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [KeyNameList, setKeyNames] = useState([]);
    const [IndustrySectorList, setIndustrySector] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [phone, setPhone] = useState();
    const [mobile, setMobile] = useState();
    const [stockCategoryList, setStockCategories] = useState([]);
    const fetchIndustrySectors = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const industrySectorData = await IndustrySectorService.GetIndustrySector(redirectCallback);
            setIndustrySector(industrySectorData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, ClientCompanyID, "2");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };
    const handleFieldChange = (event, keyItem = null) => {
        const { name, value } = event.target;
        setIsChanged(true);
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };


    useEffect(() => {
        fetchTitle();
        fetchCountries();
        fetchAccountType();
        fetchTeams();
        fetchCourier();
        fetchTaxCode();
        fetchCurrency();
        fetchDiscount();
        fetchJobRole();
        fetchIndustrySectors();
        fetchStockCategory();
        if (ClientCompanyID === 0) {
            resetForm();
            fetchKeyNames();
        } else {
            fetchCustomerDetail();
            fetchKeyNames();
            // fetchCommunication();
        }
    }, [ClientCompanyID]); // Add ClientCompanyID as a dependency here
    const fetchJobRole = async () => {
        try {
            const list = await JobRoleService.GetAllJobRole();
            setJobRoles(list);

        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    const fetchStockCategory = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await StockCategoryService.GetAllStckCategories(redirectCallback);
            setStockCategories(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    const fetchAccountType = async () => {
        try {
            const listOfAccountType = await CustomerAccountTypeService.GetAllCustomerAccountnType();
            setAccountTypes(listOfAccountType);
        } catch (error) {
            console.error('Error fetching account types:', error);
        }
    };

    const fetchTeams = async () => {
        try {
            const listOfTeams = await TeamService.GetAllTeams();
            setTeams(listOfTeams);
            if (listOfTeams.length > 0) {
                setFormData(formData => ({
                    ...formData,
                    TeamID: listOfTeams[0].PK_Team_ID, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    const fetchTitle = async () => {
        try {
            const listOfTitles = await TitleService.GetAllTitle();
            setTitles(listOfTitles);
            if (listOfTitles.length > 0) {
                setFormData(formData => ({
                    ...formData,
                    Title: listOfTitles[0].Title, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };

    const fetchCourier = async () => {
        try {
            const listOfCourier = await CourierService.GetAllCouriers();
            setCouriers(listOfCourier);
            if (listOfCourier.length > 0) {
                setFormData(formData => ({
                    ...formData,
                    CourierID: listOfCourier[0].PK_Courier_ID, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching couriers:', error);
        }
    };

    const fetchTaxCode = async () => {
        try {
            const listOfTaxCodes = await TaxService.GetAllTaxCodes();
            setTaxCodes(listOfTaxCodes);
            if (listOfTaxCodes.length > 0 && ClientCompanyID === 0) {
                const defaultTax = listOfTaxCodes.find(t => t.IsDefault === 1);
                setFormData(formData => ({
                    ...formData,
                    FK_TaxCode_ID: defaultTax ? defaultTax.ID : listOfTaxCodes[0].ID,  // Assuming IssuePriorityID is the field name
                }));
            }

        } catch (error) {
            console.error('Error fetching tax codes:', error);
        }
    };

    const fetchCurrency = async () => {
        try {

            const listOfCurrencies = await CurrencyService.GetAllCurrencies();
            setCurrenyDate(listOfCurrencies);
            const selectedCustomer = listOfCurrencies.find(currency => currency.bit_BaseCurrency === 1);
            if (selectedCustomer) {
                setFormData(formData => ({
                    ...formData,
                    FK_Currency_ID: selectedCustomer.PK_Currency_ID, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };

    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const location = useLocation();
    const fetchCustomerDetail = async () => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            resetForm();
            setIsChanged(false);
            const CustomerID = ClientCompanyID;
            if (CustomerID > 0) {

                const CustomerDetail = await CustomerService.GetCustomerByID(redirectCallback, CustomerID);
                setPhone(CustomerDetail[0].Telephone);
                setMobile(CustomerDetail[0].Mobile);
                setFormData(CustomerDetail[0]);
            }
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };


    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (ClientCompanyID > 0 && !isChanged) {
            return;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        const redirectUserList = () => {
            navigate('/CustomerList?saved=true');
        };

        if (formData.ClientCompanyID === "undefined" || formData.ClientCompanyID === null) {
            formData.ClientCompanyID = 0;
        }
        formData.ContactTypeID = 1;
        if (formData.AccountRef != null && formData.AccountRef != "" && formData.AccountRef != "undefined") {
            const IsAccountNoExist = await CustomerService.IsAccountNoExist(formData.AccountRef, formData.ClientCompanyID);
            const IsCompanyExist = await CustomerService.IsCompanyExist(formData.CompanyName, formData.PostCode, formData.ClientCompanyID);
            if (IsAccountNoExist.length > 0) {
                setshowAccountNoMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setshowAccountNoMessage(false);
                }, 5000);
                return false;
            }
            if (IsCompanyExist.length > 0) {
                setshowCompanyExistMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setshowCompanyExistMessage(false);
                }, 5000);
                return false;
            }
        }

        const formDataWithParts = {
            formData: formData,
            tableData: CommunicationList,

        };
        const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors, redirectCallback, redirectUserList);
        debugger;
        if (message.message == "Data saved successfully") {
            setIsChanged(false);
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
            ClientCompanyID = localStorage.getItem('ClientCompanyID');
            await handleUserDefineSubmit({
                JobID: localStorage.getItem('ClientCompanyID'),
                fields: KeyNameList.map(key => ({
                    PK_KeyName_ID: key.PK_KeyName_ID,
                    value: formData[key.vc_Name] || ''
                }))
            });
            await fetchCustomerDetail();
            await fetchKeyNames();
            //await fetchCommunication();
            onSuccess();
            if (IsCustomerSelection === 1 || IsCustomerSelection === "1") {
                onClose(ClientCompanyID);
                return;
            }
            else {
                // redirectUserList();
            }
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }

    };
    const resetForm = () => {

        setFormData({
            ClientCompanyID: 0,
            CompanyName: "",
            Address1: "",
            Address2: "",
            Address3: "",
            City: "",
            PostCode: "",
            County: "",
            Country: 0,
            FK_ClientCompanyType_ID: 0,
            TeamID: 0,
            CourierID: 0,
            Title: "Mr",
            Forename: "",
            Surname: "",
            Mobile: "",
            Fax: "",

            Email: "",
            Telephone: "",
            Website: "",
            AccountRef: "",
            vc_AccountStatus: "active",
            FK_TaxCode_ID: 0,
            FK_Currency_ID: 0,
            FK_DiscountType_ID: 0,
            Amount: "0.00",
            CompanyEmail: "",
            IndustrialSector: '',
            NoOfEmployees: '0',
            JobRoleID: '0',
            ContactPreferred: "Email",
            PK_StockCategory_ID: "0",
            vc_Category: "",
            LinkedIn: ""
        });
    };
    const handleEmailClick = async (event, email) => {
        event.stopPropagation();
        setEmail(email)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };
    const HelpLink = localStorage.getItem('HelpLink');

    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }

                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);
    const generatePDF = async (event) => {
        event.stopPropagation();

        try {


            const blob = await getMergedPDFBlob({
                moduleId: "2",
                navigate,
                currentInputValues: {
                    ID: ClientCompanyID
                },
                defaultReportID: 117,
                setReportLink,
                setReportTitle,
                setError
            });

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);



        } catch (err) {
            console.error(err);
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const tableRef = useRef();
    const [loading, setLoading] = useState(true);
    const [CommunicationList, setCommunicationData] = useState([]);
    const [currentCommunicationHistory, setCurrentCommunicationHistory] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const truncateText = (text, maxLength = 150) => {
        if (!text) return '';  // Return empty string if text is null or empty
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await CustomerHistoryService.DeleteCustomerHistory(ID, redirectCallback)
                    //  fetchCommunication();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleEditClick = (data, index) => {

        setCurrentCommunicationHistory(data, index);
        setIsModalOpen(true);
    };
    const fetchCommunication = async () => {
        try {
            setCommunicationData([]);
            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await CustomerHistoryService.GetAllCustomerHistory(redirectCallback, ClientCompanyID);

            const selectedPartsData = data.map(detail => {
                const formattedDate = detail.dt_Created ? detail.dt_Created.slice(0, 10) : '';
                const AppointmentDate = detail.AppointmentDate ? detail.AppointmentDate.slice(0, 10) : '';
                const DueDate = detail.DueDate ? detail.DueDate.slice(0, 10) : '';
                const AppointmentEndDate = detail.AppointmentEndDate ? detail.AppointmentEndDate.slice(0, 10) : '';

                return {
                    ID: detail.PK_ContactHistory_ID,
                    snt_CommunicationType: detail.snt_CommunicationType.toString(),
                    vc_Description: detail.vc_Description,
                    dt_Created: formattedDate,
                    vc_Subject: detail.vc_Subject,
                    vc_From: detail.vc_From,
                    vc_To: detail.vc_To,
                    vc_CC: detail.vc_CC,
                    AppointmentDate: AppointmentDate,
                    StartTime: detail.StartTime,
                    Completed: detail.Completed,
                    DueDate: DueDate,
                    DueTime: detail.DueTime,
                    DisplayName: detail.DisplayName,
                    AppointmentEndDate: AppointmentEndDate,
                    EndTime: detail.EndTime,
                    UserTask: detail.UserTask,
                    AssignUserID: detail.AssignUserID,
                    StatusText: detail.StatusText,
                    Status: detail.Status,
                    EmailStatus: detail.EmailStatus,
                    IsEmailSend: detail.IsEmailSend,
                    Title: detail.Title,
                    FirstName: detail.FirstName,
                    SurName: detail.SurName,
                    FK_ClientContact_ID: detail.FK_ClientContact_ID,

                    // Map other fields as needed
                };
            });

            setCommunicationData(selectedPartsData);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const handleCommunicationSubmit = (CommunicationData) => {

        setIsChanged(true);
        if (Array.isArray(CommunicationData)) {
            const existingEntriesMap = new Map(CommunicationList.map(entry => [entry.ID, entry]));
            const updatedEntries = [];
            const newEntries = [];

            CommunicationData.forEach(data => {
                if (data.ID > 0) {
                    // Update existing entry if present
                    if (existingEntriesMap.has(data.ID)) {
                        updatedEntries.push(data);
                    } else {
                        // If an entry has a valid ID but doesn't exist, add it as new
                        newEntries.push(data);
                    }
                } else {
                    // Generate a unique EngineerTimeID for new entries
                    const newID = CommunicationList.length > 0
                        ? Math.max(...CommunicationList.map(row => row.ID)) + 1
                        : 1;
                    data.ID = 0;
                    newEntries.push(data);
                }
            });

            const finalTableData = [
                ...CommunicationList.filter(entry => !updatedEntries.some(updated => updated.ID === entry.ID)),
                ...updatedEntries,
                ...newEntries
            ];
            setCommunicationData(finalTableData);

            setIsModalOpen(false);
        }

    };
    const handleCloseModal = async () => {
        setIsChanged(true);
        if (ClientCompanyID > 0) {
            //await fetchCommunication();
        }
        setIsModalOpen(false);

    };

    const handleAddCommunicationHistory = () => {
        setCurrentCommunicationHistory(null);
        setIsModalOpen(true);
    };
    return (

        <div ref={modalRef}>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            {showAccountNoMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Duplicate entry: The Account No already exist.

                </div>
            )}
            {showCompanyExistMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Duplicate entry: A customer with the same name and postcode already exists.

                </div>
            )}



            <form onSubmit={handleFormSubmit} style={{
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100vh - 335px)",     // IE/Edge
            }}>
                <div
                    style={{
                        //flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        // scrollbarWidth: "none", // Firefox
                        // msOverflowStyle: "none", // IE/Edge
                    }}
                    className=""
                >
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td style={{ width: "13%" }}>
                                    <label htmlFor="CompanyName" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td style={{ width: "37%" }}>
                                    <input type="hidden" name="ClientCompanyID" value={formData.ClientCompanyID} onChange={handleFieldChange} />
                                    <input type="hidden" name="ClientBranchID" value={formData.ClientBranchID} onChange={handleFieldChange} />
                                    <input type="hidden" name="ClientContactID" value={formData.ClientContactID} onChange={handleFieldChange} />
                                    <input type="text" className="form-control" name="CompanyName" value={formData.CompanyName} onChange={handleFieldChange} />
                                    {errors.CompanyName && <div style={{ color: 'red' }}>{errors.CompanyName}</div>}
                                </td>
                                <td style={{ width: "13%" }}>
                                    <label htmlFor="Title" style={{ float: "right" }}>Title </label>
                                </td>

                                <td style={{ width: "37%" }}>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <select name="Title" className='form-control' value={formData.Title} onChange={handleFieldChange}>
                                                    <option value="0">Select Title</option>
                                                    {TitleList.map((title) => (
                                                        <option key={title.Title} value={title.Title}>
                                                            {title.Title}
                                                        </option>
                                                    ))}
                                                </select>

                                                {errors.Title && <div style={{ color: 'red' }}>{errors.Title}</div>}
                                            </td>
                                            <td>
                                                <label htmlFor="dec_Weight" style={{ float: "right" }}>Position &nbsp;&nbsp;</label>
                                            </td>
                                            <td>
                                                <select name="JobRoleID" className='form-control' value={formData.JobRoleID} onChange={handleFieldChange}>
                                                    <option value="0">Select Position</option>
                                                    {jobRoleList.map((jobRole) => (
                                                        <option key={jobRole.ID} value={jobRole.ID}>
                                                            {jobRole.JobRole}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="AccountRef" style={{ float: "right" }}>Account Ref &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="AccountRef" value={formData.AccountRef} onChange={handleFieldChange} />
                                    <hr />
                                </td>
                                <td>
                                    <label htmlFor="Forename" style={{ float: "right" }}>Forename <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="Forename" value={formData.Forename} onChange={handleFieldChange} />
                                    {errors.Forename && <div style={{ color: 'red' }}>{errors.Forename}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input type="text" placeholder={ClientCompanyID === 0 ? 'Address 1' : ''} className="form-control" name="Address1" value={formData.Address1} onChange={handleFieldChange} />
                                    {errors.Address1 && <div style={{ color: 'red' }}>{errors.Address1}</div>}
                                </td>
                                <td>
                                    <label htmlFor="Surname" style={{ float: "right" }}>Surname <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="Surname" value={formData.Surname} onChange={handleFieldChange} />
                                    {errors.Surname && <div style={{ color: 'red' }}>{errors.Surname}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Address3" style={{ float: "right" }}></label>
                                </td>
                                <td>
                                    <input type="text" placeholder={ClientCompanyID === 0 ? 'Address 2' : ''} className="form-control" name="Address2" value={formData.Address2} onChange={handleFieldChange} />
                                </td>
                                <td>
                                    <label htmlFor="Mobile" style={{ float: "right" }}>Mobile &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr><td>
                                            <input type="text" className="form-control" name="Mobile" value={formData.Mobile} onChange={handleFieldChange} />
                                            {errors.Mobile && <div style={{ color: 'red' }}>{errors.Mobile}</div>}
                                        </td>
                                            <td>
                                                {(ClientCompanyID > 0) && (formData.Mobile != "" && formData.Mobile != null && formData.Mobile != "undefined") && (
                                                    <a href={`tel:${formData.Mobile}`} onClick={(e) => e.stopPropagation()}>
                                                        <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                    </a>
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Address3" style={{ float: "right" }}></label>
                                </td>
                                <td>
                                    <input type="text" placeholder={ClientCompanyID === 0 ? 'Address 3' : ''} className="form-control" name="Address3" value={formData.Address3} onChange={handleFieldChange} />
                                </td>
                                <td>
                                    <label htmlFor="Email" style={{ float: "right" }}>Contact's Email &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr><td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="Email"
                                                name="Email"
                                                value={formData.Email}
                                                onChange={handleFieldChange}


                                            />

                                        </td>
                                            <td>
                                                {(ClientCompanyID > 0) && (formData.Email != "" && formData.Email != null && formData.Email != "undefined") && (
                                                    <a href='#' onClick={(event) => handleEmailClick(event, formData.Email)}>
                                                        <img src="assets/img/resources/email-icon.png" alt="Add icon" style={{ height: "22px" }} />
                                                    </a>
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="CompanyEmail" style={{ float: "right" }}>Company Email &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="CompanyEmail"
                                            name="CompanyEmail"
                                            value={formData.CompanyEmail}
                                            onChange={handleFieldChange}
                                            onDoubleClick={() => {
                                                if (formData.CompanyEmail) {
                                                    window.location.href = `mailto:${formData.CompanyEmail}`;
                                                }
                                            }}

                                        />

                                    </td>
                                        <td>
                                            {(ClientCompanyID > 0) && (formData.CompanyEmail != "" && formData.CompanyEmail != null && formData.CompanyEmail != "undefined") && (
                                                <a href='#' onClick={(event) => handleEmailClick(event, formData.CompanyEmail)}>
                                                    <img src="assets/img/resources/email-icon.png" alt="Add icon" style={{ height: "22px" }} />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="Country" style={{ float: "right" }}>Team &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="TeamID" className='form-control' value={formData.TeamID} onChange={handleFieldChange}>
                                        <option value="0">Select Team</option>
                                        {TeamList.map((team) => (
                                            <option key={team.PK_Team_ID} value={team.PK_Team_ID}>
                                                {team.vc_Name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.TeamID && <div style={{ color: 'red' }}>{errors.TeamID}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="City" style={{ float: "right" }}>Town Or City &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="City" value={formData.City} onChange={handleFieldChange} />
                                </td>
                                <td>
                                    <label htmlFor="AccountRef" style={{ float: "right" }}>Tax Code &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="FK_TaxCode_ID" className='form-control' value={formData.FK_TaxCode_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Tax Code</option>
                                        {taxCodeList.map((taxCode) => (
                                            <option key={taxCode.ID} value={taxCode.ID}>
                                                {taxCode.vc_Code} ( {taxCode.dec_Rate} )
                                            </option>
                                        ))}
                                    </select>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="County" style={{ float: "right" }}>County &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="County" value={formData.County} onChange={handleFieldChange} />
                                </td>
                                <td>
                                    <label htmlFor="vc_AccountStatus" style={{ float: "right" }}>Base Currency &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="FK_Currency_ID" className='form-control' value={formData.FK_Currency_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Currency</option>
                                        {currencyList.map((currency) => (
                                            <option key={currency.PK_Currency_ID} value={currency.PK_Currency_ID}>
                                                {currency.vc_CurrencyName}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>


                            <tr>
                                <td>
                                    <label htmlFor="PostCode" style={{ float: "right" }}>Post Code &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="PostCode" value={formData.PostCode} onChange={handleFieldChange} />
                                </td>
                                <td>
                                    <label htmlFor="CourierID" style={{ float: "right" }}>Courier &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="CourierID" className='form-control' value={formData.CourierID} onChange={handleFieldChange}>
                                        <option value="0">Select Courier</option>
                                        {CourierList.map((courier) => (
                                            <option key={courier.PK_Courier_ID} value={courier.PK_Courier_ID}>
                                                {courier.vc_Courier}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.CourierID && <div style={{ color: 'red' }}>{errors.CourierID}</div>}
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Country" style={{ float: "right" }}>Country &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="Country" className='form-control' value={formData.Country} onChange={handleFieldChange}>
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.Country && <div style={{ color: 'red' }}>{errors.Country}</div>}
                                </td>
                                <td>
                                    <label htmlFor="Discount" style={{ float: "right" }}>Discount &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="FK_DiscountType_ID" className='form-control' value={formData.FK_DiscountType_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Discount</option>
                                        {DiscountsList.map((discount) => (
                                            <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                                {discount.vc_Name}
                                            </option>
                                        ))}
                                    </select>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Telephone" style={{ float: "right" }}>Telephone &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="Telephone" value={formData.Telephone} onChange={handleFieldChange} />
                                        {errors.Telephone && <div style={{ color: 'red' }}>{errors.Telephone}</div>}
                                    </td>
                                        <td>
                                            {(ClientCompanyID > 0) && (formData.Telephone != "" && formData.Telephone != null && formData.Telephone != "undefined") && (
                                                <a href={`tel:${formData.Telephone}`} onClick={(e) => e.stopPropagation()}>
                                                    <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="Amount" style={{ float: "right" }}>Amount &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="Amount" value={formData.Amount} onChange={handleFieldChange} />
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Fax" style={{ float: "right" }}>Fax &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="Fax" value={formData.Fax} onChange={handleFieldChange} />
                                </td>
                                <td>
                                    <label htmlFor="IndustrialSector" style={{ float: "right" }}>Category &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="IndustrialSector" className='form-control' value={formData.IndustrialSector} onChange={handleFieldChange}>
                                        <option value="0">Select Category</option>
                                        {IndustrySectorList.map((industry) => (
                                            <option key={industry.IndustrialSector} value={industry.IndustrialSector}>
                                                {industry.IndustrialSector}
                                            </option>
                                        ))}
                                    </select>

                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Website" style={{ float: "right" }}>Website &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="Website" value={formData.Website} onChange={handleFieldChange} />

                                    </td>
                                        <td>

                                            {(ClientCompanyID > 0) && (formData.Website != "" && formData.Website != null && formData.Website != "undefined") && (
                                                <Website webLink={formData.Website} />
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="NoOfEmployees" style={{ float: "right" }}>Employees &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="NoOfEmployees" value={formData.NoOfEmployees} onChange={handleFieldChange} />

                                </td>


                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="Website" style={{ float: "right" }}>Contact Preferred &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="ContactPreferred" className='form-control' value={formData.ContactPreferred} onChange={handleFieldChange}>
                                        <option value="Email">Email</option>
                                        <option value="Whatsapp">Whatsapp</option>
                                    </select>

                                </td>
                                <td>
                                    <label htmlFor="PK_StockCategory_ID" style={{ float: "right" }}>Price List &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="PK_StockCategory_ID" className='form-control' value={formData.PK_StockCategory_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Price List</option>
                                        {stockCategoryList.map((stock) => (
                                            <option key={stock.PK_StockCategory_ID} value={stock.PK_StockCategory_ID}>
                                                {stock.vc_Name}
                                            </option>
                                        ))}
                                    </select>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="IndustrySector" style={{ float: "right" }}>Industry Sector &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Category" value={formData.vc_Category} onChange={handleFieldChange} />
                                    {errors.vc_Category && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Category}</div>}
                                </td>
                                <td>
                                    <label htmlFor="IndustrySector" style={{ float: "right" }}>LinkedIn Address &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <input type="text" className="form-control" name="LinkedIn" value={formData.LinkedIn} onChange={handleFieldChange} />
                                            </td>
                                            <td>
                                                {(ClientCompanyID > 0) && (formData.LinkedIn != "" && formData.LinkedIn != null && formData.LinkedIn != "undefined") && (
                                                    <Website webLink={formData.LinkedIn} />
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>
                </div>


                <div className="row" style={{ "marginLeft": "0px" }}>
                    <div className="col-sm-6">
                        <button type="button" style={{ background: "#2E7D32" }} className={`btn btn-secondary btn-sm ${isLock > 0 ? 'disabled' : ''}`}
                            disabled={isLock > 0} onClick={handleAddCommunicationHistory}>
                            <i className="icofont-plus" aria-hidden="true"></i> Add Comms</button>


                    </div>
                    <div className="col-sm-6">
                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} disabled={parseInt(isLock) > 0} style={{ "float": "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {ClientCompanyID > 0 ? ' Update' : ' Save'}

                        </button>
                        <button style={{ "marginLeft": "5px", float: "right" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>
                        <button type='button' className="btn btn-previous" style={{ float: "right", "marginLeft": "5px" }} onClick={() => onNext(isChanged)}>
                            <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} />  Next
                        </button>
                        <button type='button' className="btn btn-previous" style={{ float: "right" }} onClick={() => onPrevious(isChanged)}>
                            <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} />  Previous
                        </button>

                    </div>
                </div>

            </form>

            {isEmailModalOpen && (
                <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Customer" ModuleID={formData.ClientContactID} />
            )}


            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}

            {isModalOpen && (
                <CreateCommunicationModal
                    show={isModalOpen}
                    currentCommunicationHistory={currentCommunicationHistory}
                    onFormSubmit={handleCommunicationSubmit}
                    onClose={handleCloseModal}
                    data={formData}
                    CustomerID={ClientCompanyID}
                    Phone={phone}
                    Mobile={mobile}
                    ToEmail={Email}
                />
            )}

        </div>


    );
}
export default CustomerDetail;

